import React, { FC } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import * as analytics from '@adsk/acs-web-analytics';
import ErrorPage from '@adsk/alloy-error-page';
import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';
import {
  safeStringify,
  wrapWithEventPropertiesPrefix,
} from '@adsk/exo-skeleton-api/internal';

import { ANALYTICS_TYPES } from '../analytics';
import i18n from '../utils/i18n';
import isLocalError from '../utils/isLocalError';
import { REPORT_EVENT_TYPES } from '../utils/monitoring';

export const RootErrorBoundary: FC = () => {
  return (
    <ErrorBoundary
      fallbackRender={() => (
        <ErrorPage
          title={i18n.t('SOMETHING_WENT_WRONG')}
          description={i18n.t('ERROR_PAGE_DESCRIPTION')}
        />
      )}
      onError={(error, { componentStack }) => {
        if (isLocalError(error)) return; // Don't report local errors

        analytics.track(ANALYTICS_TYPES.EXO_LOAD_ERROR, {
          error_description: error.message,
        });

        const unsafeGlobalContext = {
          type: REPORT_EVENT_TYPES.ROOT_ERROR,
          componentStack,
        };

        void report({
          type: REPORT_TYPES.error,
          value: error,
          context: {
            ...wrapWithEventPropertiesPrefix({
              stack: error?.stack,
              message: error?.message,
              type: REPORT_TYPES.error,
              data: safeStringify(unsafeGlobalContext),
            }),
          },
          UNSAFE__globalContext: unsafeGlobalContext,
        });
      }}
    >
      <Outlet />
    </ErrorBoundary>
  );
};
